<template>
  <div class="justify-content-center text-left dp02 p-5">
    <div class="col-lg-12">
      <b-button type="submit"
                class="myButton"
                @click="$router.go(-1)"
                style="float:left">
        {{ $t('common.Back') }}
      </b-button>
    </div>
    <div v-if="!ready"
         class="row mt-5">
      <b-spinner variant="primary"
                 type="grow"
                 label="Spinning" />
      <span>{{ $t('DataTable.Loading') }}...</span>
    </div>
    <div v-else
         class="row col-lg-12 mt-5">
      <div class="col-12">
        <h2>{{ name }} {{ surname }}</h2>
      </div>
      <div class="col-4">
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.street') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="address.street" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.streetNumber') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="address.streetNumber" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.city') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="address.city" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.zipCode') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="address.zipCode" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.name') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="name" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.surname') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="surname" />
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.gender') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              :value="$t(gender.value === 2 ? 'common.Male' : 'common.Female')" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-5">
            <label for="gender">{{ $t('fields.agreedToDataProcessing') }}:</label>
          </div>
          <div class="col-lg-4">
            <b-form-checkbox
              :disabled="true"
              v-model="agreedToDataProcessingComputed" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-5">
            <label for="gender">{{ $t('fields.agreedToTermsOfService') }}:</label>
          </div>
          <div class="col-lg-4">
            <b-form-checkbox
              :disabled="true"
              v-model="agreedToTermsOfServiceComputed" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-5">
            <label for="gender">{{ $t('fields.agreedToDNAAnalysis') }}:</label>
          </div>
          <div class="col-lg-4">
            <b-form-checkbox
              :disabled="true"
              v-model="agreedToDNAAnalysisComputed" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.phone') }}:</label>
          </div>
          <div class="col-lg-9">
            <PhoneNumberInput
              :editable="false"
              v-model="phone" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.email') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="email" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import PhoneNumberInput from '@components/input/PhoneNumberInput';
import { downloadBlob } from '@utils/downloadBlob';

export default {
  name: 'CustomerViewDetail',
  components: {
    PhoneNumberInput
  },
  data() {
    return {
      ready: false
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    ...mapState('viewCustomer', ['address',
      'gender',
      'email',
      'name',
      'surname',
      'agreedToDataProcessing',
      'agreedToTermsOfService',
      'agreedToDNAAnalysis',
      'phone']),
    agreedToDataProcessingComputed: {
      get() {
        return this.agreedToDataProcessing;
      },
      set(val) {
        return val;
      }
    },
    agreedToTermsOfServiceComputed: {
      get() {
        return this.agreedToTermsOfService;
      },
      set(val) {
        return val;
      }
    },
    agreedToDNAAnalysisComputed: {
      get() {
        return this.agreedToDNAAnalysis;
      },
      set(val) {
        return val;
      }
    },
  },
  created() {
    this.setCustomerId(this.id);
    this.fetchCustomer();
    this.fetchCategories()
      .then(() => {
        this.ready = true;
      });
  },
  methods: {
    ...mapActions({ fetchCustomer: 'viewCustomer/fetchCustomer',
      resetContext: 'viewCustomer/resetContext',
      fetchCategories: 'viewCustomer/fetchCategories' }),
    ...mapMutations({ setCustomerId: 'viewCustomer/setCustomerId' }),
    getBarcode() {
      this.axios.get(`admin/barcode/${this.id}`, { responseType: 'arraybuffer' }).then((response) => {
        downloadBlob(response.data, `Čárový kód zákazníka ${this.name} ${this.surname}.png`, 'image/png');
        this.$refs.downloadModal.hide();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
